var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cpage-meta\u003EIdentity check\u003C\u002Fpage-meta\u003E\u003Cdiv ng-if=\"!vm.loaded\"\u003E\u003Cmd-progress-linear md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"vm.loaded\"\u003E\u003Cdiv ng-if=\"vm.submitted\" layout=\"row\" layout-align=\"center center\"\u003E\u003Ch2 class=\"main\" flex-gt-sm=\"50\"\u003EThank you. We will contact you if we need anything more.\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!vm.submitted\"\u003E\u003Cdiv layout=\"column\"\u003E\u003Cdiv class=\"header\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cdiv flex-gt-sm=\"66\" layout=\"column\" layout-align=\"center start\" ng-if=\"!vm.owner\"\u003E\u003Ch2\u003EThis invitation has been removed or has already been completed.\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv flex-gt-sm=\"66\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.owner.isBorrower || vm.owner.isLoanEnquiry\"\u003E\u003Ch2\u003ELoan enquiry for {{ vm.owner.name }} \u003C\u002Fh2\u003E\u003Cdiv class=\"explanation\"\u003EWe understand you are a \u003Cstrong\u003Ebeneficial owner or beneficiary\u003C\u002Fstrong\u003E so need to know a little more about you. Please complete the form below so that we may fully review the enquiry.\u003C\u002Fdiv\u003E\u003Creferrer-assistance metadata=\"vm.owner.metadata\"\u003E\u003C\u002Freferrer-assistance\u003E\u003C\u002Fdiv\u003E\u003Cdiv flex-gt-sm=\"66\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.owner.isInvestor\"\u003E\u003Ch2\u003EInvestor application for {{ vm.owner.name }}\u003C\u002Fh2\u003E\u003Cdiv class=\"explanation\"\u003EWe understand you are a \u003Cstrong\u003Ebeneficial owner or beneficiary\u003C\u003C\u002Fstrong\u003E so need to know a little more about you. Please complete the form below so that we may fully review the application.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!vm.owner\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-card flex-gt-sm=\"66\" flex\u003E\u003Cmd-card-content\u003E\u003Cdiv class=\"explanation\"\u003EPlease \u003Ca ui-sref=\"contactUs\" aria-label=\"Contact us\"\u003EContact us\u003C\u002Fa\u003E directly if you believe there has been a problem with your application.\u003C\u002Fdiv\u003E\u003C\u002Fmd-card-content\u003E\u003C\u002Fmd-card\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"vm.owner\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-card flex-gt-sm=\"66\" flex\u003E\u003Cmd-card-content\u003E\u003C!-- We force email entry for representatives: Trello card #2580 --\u003E\u003Cregistration-form user-identity-promise=\"vm.userIdentityPromise\" validate-on-entry=\"!!vm.owner.email\" verification-started=\"vm.verificationStartedHandler\" completion=\"vm.registrationCompletionHandler\" force-email-entry=\"true\" loan-purpose=\"vm.loanPurpose\" loan-origination=\"vm.loanOrigination\"\u003E\u003Cdiv ng-if=\"vm.owner.isBorrower || vm.owner.isLoanEnquiry\"\u003E\u003Cmd-checkbox class=\"md-align-top-left\" required ng-model=\"vm.owner.consent.hasAuthorisedCreditCheck\"\u003E\u003Ccontent-item content-item-name=\"check-identity-consent-agreement\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fmd-checkbox\u003E\u003C\u002Fdiv\u003E\u003C\u002Fregistration-form\u003E\u003C\u002Fmd-card-content\u003E\u003C\u002Fmd-card\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;